// Subscription plans come from the backend Pricing Catalog (GET /subscription-plans).
// Prices are never computed here: a duration a plan does not list is not for sale.

const LEGACY_TIER_TO_PLAN_CODE = { tier1: 'starter', tier2: 'professional', tier3: 'enterprise' }

export function normalizePlanCode(code) {
  return LEGACY_TIER_TO_PLAN_CODE[code] ?? code ?? null
}

export function sellablePlans(plans) {
  if (!Array.isArray(plans)) return []
  return plans
    .filter((plan) => !plan?.is_custom_price && Array.isArray(plan?.billing_options) && plan.billing_options.length > 0)
    .sort((a, b) => (Number(a?.sort_order) || 0) - (Number(b?.sort_order) || 0))
}

export function planOption(plan, durationMonths) {
  const options = Array.isArray(plan?.billing_options) ? plan.billing_options : []
  return options.find((item) => Number(item?.duration_months) === Number(durationMonths)) ?? null
}

// One button per duration any sellable plan offers, labelled from the first plan listing it.
export function planDurations(plans) {
  const byMonths = new Map()
  for (const plan of sellablePlans(plans)) {
    for (const option of plan.billing_options) {
      const months = Number(option?.duration_months)
      if (months && !byMonths.has(months)) byMonths.set(months, option)
    }
  }
  return [...byMonths.entries()]
    .sort(([a], [b]) => a - b)
    .map(([months, option]) => ({
      months,
      label: option?.label ?? null,
      discountPercent: option?.discount_percent ?? null,
    }))
}
